// extracted by mini-css-extract-plugin
export default {"richText":"styles__richText___qcbX9","content":"styles__content___RsX0S"};